"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoggerTransportType = void 0;
let LoggerTransportType = exports.LoggerTransportType = /*#__PURE__*/function (LoggerTransportType) {
  LoggerTransportType["CONSOLE"] = "console";
  LoggerTransportType["APPLICATION_INSIGHTS"] = "applicationInsights";
  return LoggerTransportType;
}({});
//# sourceMappingURL=LoggerTransportType.js.map